import axios from 'axios'

class CityAPI {
  getCities = async (lang: string) => {
    return axios.get(`api/cities?lang=` + lang)
  }
}

export const cityAPI = new CityAPI()
